import { graphql } from 'gatsby';
import tw, { type TwStyle } from 'twin.macro';

const calcPaddingTop = (value: Queries.kontent_snippet_padding_padding__top_enum): TwStyle => {
  switch (value) {
    case 'medium':
      return tw`pt-4 md:pt-8`;
    case 'large':
      return tw`pt-8 md:pt-[128px]`;
    case 'none':
      return tw`pt-0`;
  }
};

const calcPaddingBottom = (
  value: Queries.kontent_snippet_padding_padding__bottom_enum
): TwStyle => {
  switch (value) {
    case 'medium':
      return tw`pb-4 md:pb-8`;
    case 'large':
      return tw`pb-8 md:pb-[128px]`;
    case 'none':
      return tw`pb-0`;
  }
};

export const DEFAULT_PADDING = 'medium';

export type PaddingProps = {
  paddingTop: Queries.kontent_snippet_padding_padding__top_enum;
  paddingBottom: Queries.kontent_snippet_padding_padding__bottom_enum;
};

export type PaddingGeneratorArgs = {
  top: Queries.kontent_snippet_padding_padding__top_enum | null;
  bottom: Queries.kontent_snippet_padding_padding__bottom_enum | null;
};

export const forwardPadding = (props: Queries.PADDINGFragment): PaddingProps => ({
  paddingTop: props.padding__top?.value ?? DEFAULT_PADDING,
  paddingBottom: props.padding__bottom?.value ?? DEFAULT_PADDING,
});

/**
 * We need to redefine the output type here because of the types generated by Gatsby
 * that include a union too big to be handled by TS in some cases.
 */
type PaddingGeneratorOutput = {
  padding__top: {
    value: Queries.kontent_snippet_padding_padding__top_enum | null;
  } | null;
  padding__bottom: {
    value: Queries.kontent_snippet_padding_padding__bottom_enum | null;
  } | null;
};

export const generatePadding = (props: PaddingGeneratorArgs): PaddingGeneratorOutput => ({
  padding__top: { value: props.top },
  padding__bottom: { value: props.bottom },
});

export const applyPaddingCSS = (props: Queries.PADDINGFragment): TwStyle[] =>
  applyPaddingStyles(forwardPadding(props));

export const applyPaddingStyles = (props: PaddingProps): TwStyle[] => [
  calcPaddingTop(props.paddingTop),
  calcPaddingBottom(props.paddingBottom),
];

export const fragment = graphql`
  fragment PADDING on kontent_snippet_padding {
    padding__top {
      value
    }
    padding__bottom {
      value
    }
  }
`;
